export enum PingAuthStatus {
    NOT_INITIALIZED = 'NOT_INITIALIZED',
    INITIALIZING = 'INITIALIZING',
    LOGGED_IN = 'LOGGED_IN',
    NOT_LOGGED_IN = 'NOT_LOGGED_IN',
    ERROR = 'ERROR',
}
